import React from 'react'

type WorkspaceOnboardingContextProps = {
    accountId: string
}

export const WorkspaceOnboardingContext =
    React.createContext<WorkspaceOnboardingContextProps | null>(null)
